// register modal component
Vue.component('modal', {
  template: '#modal-template',
  props: ['teste'],
  mounted: function(){
  }
})

var app = new Vue({
  el: '#app-vue',
  data:{
    teste: "Teste",
    partidos: [
      {nome: 'PT', blocos: '6:01', ins: '8:26', media: '14:27', selecionado: false},
      {nome: 'MDB', blocos: '5:51', ins: '8:11', media: '14:02', selecionado: false},
      {nome: 'PSDB', blocos: '4:53', ins: '6:50', media: '11:43', selecionado: false},
      {nome: 'PP', blocos: '3:29', ins: '4:52', media: '8:21', selecionado: false},
      {nome: 'PSD', blocos: '3:18', ins: '4:37', media: '7:55', selecionado: false},
      {nome: 'PSB', blocos: '3:08', ins: '4:23', media: '7:30', selecionado: false},
      {nome: 'PR', blocos: '3:08', ins: '4:23', media: '7:30', selecionado: false},
      {nome: 'PTB', blocos: '2:20', ins: '3:16', media: '5:36', selecionado: false},
      {nome: 'PRB', blocos: '1:59', ins: '2:47', media: '4:46', selecionado: false},
      {nome: 'DEM', blocos: '1:59', ins: '2:47', media: '	4:46', selecionado: false},
      {nome: 'PDT', blocos: '1:54', ins: '2:39', media: '4:33', selecionado: false},
      {nome: 'SD', blocos: '1:28', ins: '2:03', media: '3:30', selecionado: false},
      {nome: 'PSC', blocos: '1:17', ins: '1:48', media: '3:05', selecionado: false},
      {nome: 'Pros', blocos: '1:01', ins: '1:26', media: '2:27', selecionado: false},
      {nome: 'PPS', blocos: '1:01', in: '1:26', media: '2:27', selecionado: false},
      {nome: 'PCdoB', blocos: '00:51', ins: '1:11', media: '2:02', selecionado: false},
      {nome: 'PV', blocos: '00:51', ins: '	1:11', media: '2:02', selecionado: false},
      {nome: 'PSol', blocos: '00:35', ins: '00:49', media: '1:24', selecionado: false},
      {nome: 'PHS', blocos: '00:35', ins: '00:49', media: '1:24', selecionado: false},
      {nome: 'Rede', blocos: '00:30', ins: '00:41', media: '1:11', selecionado: false},
      {nome: 'Podemos', blocos: '00:30', ins: '00:41', media: '1:11', selecionado: false},
      {nome: 'PRP', blocos: '00:24', ins: '00:34', media: '00:58', selecionado: false},
      {nome: 'PMN', blocos: '00:24', ins: '00:34', media: '00:58', selecionado: false},
      {nome: 'PEN', blocos: '00:19', ins: '00:27', media: '00:46', selecionado: false},
      {nome: 'PSDC', blocos: '00:19', ins: '00:27', media: '00:46', selecionado: false},
      {nome: 'PTC', blocos: '00:19', ins: '00:27', media: '00:46', selecionado: false},
      {nome: 'Avante', blocos: '00:14', ins: '00:19', media: '00:33', selecionado: false},
      {nome: 'PSL', blocos: '00:14', ins: '00:19', media: '00:33', selecionado: false},
      {nome: 'PRTB', blocos: '00:14', ins: '00:19', media: '00:33', selecionado: false},
      {nome: 'PMB', blocos: '00:14', ins: '00:19', media: '00:33', selecionado: false},
      {nome: 'PSTU', blocos: '00:09', ins: '00:12', media: '00:21', selecionado: false},
      {nome: 'PCB', blocos: '00:09', ins: '00:12', media: '00:21', selecionado: false},
      {nome: 'PCO', blocos: '00:09', ins: '00:12', media: '00:21', selecionado: false},
      {nome: 'PPL', blocos: '00:09', ins: '00:12', media: '00:21', selecionado: false},
      {nome: 'Novo', blocos: '00:09', ins: '00:12', media: '00:21', selecionado: false},

    ],
    showModal: false
  },
  methods:{
    calc_total: function() {
      return 100;
    },
    size_p: function(){
      var t = 6 - this.partidos.filter(function(p){ return p.selecionado}).length;
      return t > 0 ? t : 0;
    },
    total_blocos: function(){
      var t = '00';
      this.partidos.forEach(el => {
        el.selecionado && (t = this.add_time(t, el.blocos));
      });
      return t;
    },
    total_ins: function(){
      var t = '00';
      this.partidos.forEach(el => {
        el.selecionado && (t = this.add_time(t, el.ins));
      });
      return t;
    },
    total_media: function(){
      var t = '00';
      this.partidos.forEach(el => {
        el.selecionado && (t = this.add_time(t, el.media));
      });
      return t;
    },
    add_time: function(startTime, endTime){
      var times = [ 0, 0 ]
      var max = times.length

      var a = (startTime || '').split(':')
      var b = (endTime || '').split(':')

      // normalize time values
      for (var i = 0; i < max; i++) {
        a[i] = isNaN(parseInt(a[i])) ? 0 : parseInt(a[i])
        b[i] = isNaN(parseInt(b[i])) ? 0 : parseInt(b[i])
      }

      // store time values
      for (var i = 0; i < max; i++) {
        times[i] = a[i] + b[i]
      }

      var minutes = times[0]
      var seconds = times[1]
      // var seconds = times[2]

      if (seconds >= 60) {
        var m = (seconds / 60) << 0
        minutes += m
        seconds -= 60 * m
      }

      return ('0' + minutes).slice(-2) + ':' + ('0' + seconds).slice(-2)
    }
  }
});

